module.exports = __webpack_public_path__ + "assets/img/cec21bdaa38437206d0a60657306b932.svg";